import PainelModulos from './PainelModulos';

export default PainelModulos;